<template>
    <v-card :class="appliedClass" :variant="variant" :elevation="elevation">
        <template v-if="isLoading">
            <v-skeleton-loader type="card" class="mx-auto"></v-skeleton-loader>
        </template>
        <template v-else>
            <slot />
        </template>
    </v-card>
</template>

<script setup lang="ts">
import { useAttrs, computed } from 'vue';
import { CardVariant } from '../types';
interface ICardSkeleton {
    isLoading?: boolean;
    className?: string;
    variant?: CardVariant;
    elevation?: string;
}

const props = withDefaults(defineProps<ICardSkeleton>(), {
    className: 'mb-6 rounded-lg px-2 py-2',
    variant: 'flat',
    elevation: '0'
});

const attrs = useAttrs();
const appliedClass = computed(() => {return (attrs as any).class ?? props.className; });
</script>
